import times from 'lodash/times';

export default class PassengerDetailsDataBuilder {
  constructor(pax) {
    this.data = {};
    this.pax = pax;
  }

  flightsIds(state) {
    this.data = {
      ...this.data,
      flight_id: state.flightId,
      ...(state.returnFlightId ? { return_flight_id: state.flight_id } : {}),
    };

    return this;
  }

  contactPerson(state) {
    this.data = {
      ...this.data,
      contact_name: `${state.firstName.trim()} ${state.lastName.trim()}`,
      contact_email: state.contactEmail,
      contact_mobile: state.contactMobile.toString(),
    };

    return this;
  }

  passengerDetail(inst) {
    const passenger_detail = [];

    times(this.pax).forEach((e, i) => {
      const { title, firstName, lastName, nationality } = inst[
        `passenger${i}`
      ].state.values;

      passenger_detail.push({
        pax_type: 'Adult',
        title,
        gender: title === 'Mr' ? 'M' : 'F',
        first_name: firstName,
        last_name: lastName,
        nationality: nationality,
      });
    });

    this.data = {
      ...this.data,
      passenger_detail,
    };

    return this;
  }

  build() {
    return this.data;
  }
}



// WEBPACK FOOTER //
// ./src/screens/Trek/Self-Guided/CustomerDetails/PassengerDetailsDataBuilder.js